module.exports = __webpack_public_path__ + "static/media/nc.0dba674e.svg";